import { addHash } from '@/services/mixins/playerMixins'
import Player from './player'

class OutstreamPlayer extends Player {
  constructor() {
    super()
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~ //
    // SETUP
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~ //

    this.playButton = true
    this.volumeSlider = true
    this.muteButton = true
    this.viewableThresholdPercentage = 0.5

    this.width = 640
    this.height = 360
    this.playerSizeTypeId = 1
    this.responsiveSizeOptionId = 1
    this.highlightCurrentVideo = false
    this.delayLiveVideosTime = 0
    this.delayLiveVideos = false
    this.showPlayerControlsDuringVideoAdvertisement = false

    this.autoStartOnLoad = true
    this.autoStartOnLoadMobile = false
    this.autoStartOnLoadOnData = false

    this.socialNetworkIds = []

    this.responsiveSizeOption = {
      id: 1,
      name: '16:9',
      width: 16,
      height: 9,
    }
    this.playerSizeType = {
      id: 1,
      name: 'Responsive',
    }
    this.responsive = true

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~ //
    // COSTUMIZE
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~ //

    this.controlBarIconsDefaultColor = '#ffffff'
    this.controlBarIconsHoverColor = '#ffffff'

    this.controlBarSliderProgressColor = '#F26822'
    this.controlBarSliderRailColor = '#FFFFFF80'
    this.controlBarSliderDraggerColor = '#FFFFFFB2'
  }

  fromData(data) {
    super.fromData(data)

    this.playButton = data.playButton ?? this.playButton
    this.volumeSlider = data.volumeSlider ?? this.volumeSlider
    this.muteButton = data.muteButton ?? this.muteButton
    this.viewableThresholdPercentage = data.viewableThresholdPercentage || 0.5

    this.width = data.width || 640
    this.height = data.height || 360
    this.playerSizeTypeId = data.playerSizeTypeId || 1
    this.responsiveSizeOptionId = data.responsiveSizeOptionId || 1
    this.highlightCurrentVideo = data.highlightCurrentVideo
    this.delayLiveVideos = data.delayLiveVideos
    this.delayLiveVideosTime = data.delayLiveVideosTime || 0
    this.showPlayerControlsDuringVideoAdvertisement = data.showPlayerControlsDuringVideoAdvertisement

    this.autoStartOnLoad = data.autoStartOnLoad
    this.autoStartOnLoadMobile = data.autoStartOnLoadMobile
    this.autoStartOnLoadOnData = data.autoStartOnLoadOnData

    this.socialNetworkIds = data.socialNetworkIds

    this.responsiveSizeOption = data.responsiveSizeOption || {
      id: 1,
      name: '16:9',
    }
    this.playerSizeType = data.playerSizeType || {
      id: 1,
      name: 'Responsive',
    }
    this.responsive = data.responsive ?? this.responsive

    this.controlBarIconsDefaultColor = addHash(data.controlBarIconsDefaultColor) || '#ffffff'
    this.controlBarIconsHoverColor = addHash(data.controlBarIconsHoverColor) || '#ffffff'

    this.controlBarSliderProgressColor = addHash(data.controlBarSliderProgressColor) || '#F26822'
    this.controlBarSliderRailColor = addHash(data.controlBarSliderRailColor) || '#FFFFFF80'
    this.controlBarSliderDraggerColor = addHash(data.controlBarSliderDraggerColor) || '#FFFFFFB2'
  }
}

export default OutstreamPlayer
